<div class="filters" [ngClass]="{'filter-align' : modal}">
    <h1 *ngIf="!modal">{{'msg#label.filters' | sqMessage}}</h1>
    <div class="clearAll" *ngIf="!modal">
        <button class="clear-btn" (click)="clearAll()">{{'msg#label.clearAll' | sqMessage}}
            <span class="close-btn">x</span></button>
    </div>
    <div *ngFor="let dropdown of dropdownsList">
        <div class="dropdowns" [ngClass]="{'display_dropdown': dropdown.hide}">
            <em>{{dropdown.name}}</em>
            <div *ngIf="!dropdown.hide" (sqClickOutside)="clickOutside(dropdown)">
                <button class="drop-toggle flat" [ngClass]="{'toggle-align': modal}" (click)="showOptions(dropdown)">
                    <span *ngIf="facet.filterItem.length<=0" class="select">{{dropdown.name}}</span>
                    <span *ngIf="facet.filterItem.length>0" class="display-text">{{facet.showFiltered()}}</span>
                    <i *ngIf="!dropdown.showOption" class="fas fa-caret-down fa-fw"></i>
                    <i *ngIf="dropdown.showOption" class="fas fa-caret-up fa-fw"></i>
                </button>
                <div class="drop-show" [class.hideoption]="!dropdown.showOption">
                    <sq-facet-card [title]="dropdown.name" [hideCard]="true" class="mb-3">
                        <sq-facet-list #facet [results]="results" [hideCard]="true" [aggregation]="dropdown.display"
                            [dropdown]="dropdown" (selectedOptions)="getSelectedValue($event)" (clearSelected)="clearFilter($event)"
                            (clearOptions)="dropdown.checkedList = clearOptions(dropdown.checkedList)" [alignOptions]="true"></sq-facet-list>
                    </sq-facet-card>
                   
                </div>
            </div>
        </div>
    </div>
</div>